const KEY = 'psflex.v1'

function StorageService () {
    this.tabs = []
    this.activeTab = -1
    this.timer = null
    this.tabListChangeListeners = []
    this.activeTabChangeListeners = []
    this.tabRemoveListeners = []
    this.language = {
        selection: 'default',
        customConfig: null
    }
    this.preferences = {}
}

StorageService.prototype = {
    init () {
        if (this.hasKey(KEY)) {
            let data = this.getKey(KEY)
            this.tabs = data.tabs
            this.activeTab = data.activeTab
            if (data.language) {
                this.language = data.language
            }
            if (data.preferences) {
                this.preferences = data.preferences
            }
        }
        this.restorePreviousConfig()
    },
    restorePreviousConfig () {
        let keys = Object.keys(localStorage)
        for (let key of keys) {
            if (key.startsWith('pscode_code_editor_')) {
                let prevId = key.substr(19)
                let foundLocal = this.tabs.find(tab => tab.id === prevId) !== undefined
                if (!foundLocal) {
                    let prevData = this.getKey(key)
                    this.tabs.push({
                        id: prevId,
                        title: '',
                        type: 'CodeEditor',
                        data: {
                            code: prevData.code
                        }
                    })
                    this.removeKey(key)
                }
            }
        }
        if (this.tabs.length > 0 && this.activeTab < 0) {
            this.activeTab = 0
        }
    },
    onTabListChange (listener) {
        this.tabListChangeListeners.push(listener)
    },
    onTabRemove (listener) {
        this.tabRemoveListeners.push(listener)
    },
    onActiveTabChange (listener) {
        this.activeTabChangeListeners.push(listener)
    },
    notifyTabListChange () {
        this.tabListChangeListeners.forEach(listener => listener(this.tabs))
    },
    notifyActiveTabChange () {
        this.activeTabChangeListeners.forEach(listener => listener(this.getActiveTab()))
    },
    notifyTabRemove (id) {
        this.tabRemoveListeners.forEach(listener => listener(id))
    },
    queueSave () {
        if (this.timer !== null) {
            clearTimeout(this.timer)
        }
        this.timer = setTimeout(this.saveAll.bind(this), 500)
    },
    saveAll () {
        this.setKey(KEY, {
            tabs: this.tabs,
            activeTab: this.activeTab,
            language: this.language,
            preferences: this.preferences
        })
    },
    notifyAllAndSave () {
        this.notifyTabListChange()
        this.notifyActiveTabChange()
        this.queueSave()
    },
    getTabList () {
        let list = []
        for (let tab of this.tabs) {
            list.push({
                id: tab.id,
                type: tab.type,
                title: tab.title
            })
        }
        return list
    },
    getTabData (id) {
        let index = this.tabIndexFromId(id)
        if (index >= 0) {
            return this.tabs[index].data
        }
        return null
    },
    getActiveTab () {
        if (this.activeTab >= 0) {
            return this.tabs[this.activeTab]
        }
        return null
    },
    setActiveTab (id) {
        let index = this.tabIndexFromId(id)
        if (index >= 0) {
            this.activeTab = index
        }
        this.notifyActiveTabChange()
        this.queueSave()
    },
    createTab (type, title, data) {
        this.tabs.push({
            id: this.uniqueid(),
            type,
            title,
            data
        })
        this.activeTab = this.tabs.length - 1
        this.notifyAllAndSave()
    },
    updateTabData (id, data) {
        let index = this.tabIndexFromId(id)
        if (index >= 0) {
            this.tabs[index].data = data
            this.queueSave()
        }
    },
    updateTabTitle (id, title) {
        let index = this.tabIndexFromId(id)
        if (index >= 0) {
            this.tabs[index].title = title
            this.notifyTabListChange()
            this.queueSave()
        }
    },
    removeTab (id) {
        let index = this.tabIndexFromId(id)
        if (index >= 0) {
            this.tabs.splice(index, 1)
            if (this.tabs.length === 0) {
                this.activeTab = -1
            } else {
                this.activeTab = Math.max(0, index - 1)
            }
        }
        this.notifyAllAndSave()
    },
    saveLanguageConfig (config) {
        this.language.customConfig = config
        this.queueSave()
    },
    getLanguageConfig () {
        return this.language.customConfig
    },
    savePreference (name, value) {
        this.preferences[name] = value
        this.queueSave()
    },
    getPreference (name, defaultValue) {
        if (this.preferences[name] !== undefined) {
            return this.preferences[name]
        }
        return defaultValue
    },
    setLanguageSelection (selection) {
        this.language.selection = selection
        this.queueSave()
    },
    getLanguageSelection () {
        return this.language.selection
    },
    getKey (key) {
        let data = localStorage.getItem(key)
        return JSON.parse(data)
    },
    setKey (key, data) {
        localStorage.setItem(key, JSON.stringify(data))
    },
    hasKey (key) {
        return !!(localStorage.getItem(key))
    },
    removeKey (key) {
        localStorage.removeItem(key)
    },
    tabIndexFromId (id) {
        return this.tabs.findIndex(tab => tab.id === id)
    },
    uniqueid () {
        let a = Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
        let b = Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
        return a + b
    }
}

export const Storage = new StorageService()



// WEBPACK FOOTER //
// ./src/Storage.js